import CityServicePage from "@/pages/city-service/CityServicePage";
import { mississaugaCommercial } from "@/mocks/cityServiceData";
export default function Page() { return <CityServicePage config={mississaugaCommercial} />; }
